import { createFileRoute } from "@tanstack/react-router";
import { AboutPage } from "@/components/blocks/pages/AboutPage";
import { getTranslator } from "@/lib/i18n";
import { resolveLocaleForPath } from "@/lib/i18n/locale";
import { buildSeo } from "@/lib/seo";

export const Route = createFileRoute("/{-$locale}/about")({
	component: AboutPage,
	loader: ({ location, serverContext }) => ({
		locale: resolveLocaleForPath(location.pathname, serverContext),
	}),
	head: ({ loaderData }) => {
		if (!loaderData) return {};
		const t = getTranslator(loaderData.locale);
		return buildSeo({
			title: t((t) => t.seo.aboutTitle),
			description: t((t) => t.seo.aboutDescription),
			path: "/about",
			locale: loaderData.locale,
		});
	},
});
